import React from 'react';
import { Link } from '@tanstack/react-router';

import MemoryAssets from '../MemoryCard/Assets';
import MemoryCardStats from '../MemoryCard/Stats';

import { formatDate } from '../../helpers';
import { setShareModalMemory } from '../../helpers/memory';

import type { Memory } from '../../types/memory';

const MemoryCard: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <wa-card className={`memory-card dashboard-memory-card memory-card-${memory.variant}`}>
      <div className="dashboard-memory-card-content wa-stack wa-gap-2xs">
        <MemoryAssets files={memory.assets} variant={memory.variant} />
        {memory.title && (
          <h5 className="dashboard-memory-card-title">
            {memory.title}
          </h5>
        )}
        {memory.variant === 'memory' ? (
          <div className="memory-card-meta dashboard-memory-card-date">
            {formatDate(memory.created_at)} · {memory.dedicated_to}
          </div>
        ) : (
          <div className="memory-card-meta dashboard-memory-card-date">
            {formatDate(memory.created_at)}
          </div>
        )}
        <hr />
        <MemoryCardStats memory={memory} />
        <div className="wa-cluster dashboard-card-buttons dashboard-memory-card-buttons" style={{ '--min-column-size': '1em' } as React.CSSProperties}>
          <Link to="#" data-dialog="open share-modal" onClick={(e) => { e.preventDefault(); setShareModalMemory(memory.id); } }>
            <i className="fa-light fa-arrow-up-from-bracket" slot="start" />
            Share
          </Link>
          <Link to={`/memories/${memory.id}/edit`}>
            <i className="fa-light fa-pencil" slot="start" />
            Edit
          </Link>
          <Link to={`/m/${memory.id}`}>
            <i className="fa-light fa-eye" slot="start" />
            View
          </Link>
          <Link to={`/dashboard/${memory.variant === 'sprk' ? 'sprks' : 'memories'}/${memory.id}`}>
            <i className="fa-light fa-chart-simple" slot="start" />
            Stats
          </Link>
        </div>
      </div>
    </wa-card>
  );
}

export default MemoryCard;
